import v1_0_0 from "./v1_0_0";
import v1_0_1 from "./v1_0_1";
import v1_1_0 from "./v1_1_0";
import v1_1_1 from "./v1_1_1";
import v1_1_2 from "./v1_1_2";
import v1_2_0 from "./v1_2_0";
import v1_3_0 from "./v1_3_0";
import v1_3_1 from "./v1_3_1";
import v1_3_2 from "./v1_3_2";
import v1_3_3 from "./v1_3_3";
import v1_3_4 from "./v1_3_4";
import v1_3_5 from "./v1_3_5";
import v1_3_6 from "./v1_3_6";
import v1_4_0 from "./v1_4_0";
import v1_4_1 from "./v1_4_1";
import v1_4_2 from "./v1_4_2";
import v1_5_0 from "./v1_5_0";
import v1_5_1 from "./v1_5_1";
import v1_5_2 from "./v1_5_2";
import v1_5_3 from "./v1_5_3";
import v1_5_4 from "./v1_5_4";
import v1_5_5 from "./v1_5_5";
import v1_5_6 from "./v1_5_6";
import v1_5_7 from "./v1_5_7";
import v1_5_8 from "./v1_5_8";
import v1_6_0 from "./v1_6_0";
import v1_6_1 from "./v1_6_1";
import v1_6_2 from "./v1_6_2";
import v1_6_3 from "./v1_6_3";

export default {
    '1.6.3': v1_6_3,
    '1.6.2': v1_6_2,
    '1.6.1': v1_6_1,
    '1.6.0': v1_6_0,
    '1.5.8': v1_5_8,
    '1.5.7': v1_5_7,
    '1.5.6': v1_5_6,
    '1.5.5': v1_5_5,
    '1.5.4': v1_5_4,
    '1.5.3': v1_5_3,
    '1.5.2': v1_5_2,
    '1.5.1': v1_5_1,
    '1.5.0': v1_5_0,
    '1.4.2': v1_4_2,
    '1.4.1': v1_4_1,
    '1.4.0': v1_4_0,
    '1.3.6': v1_3_6,
    '1.3.5': v1_3_5,
    '1.3.4': v1_3_4,
    '1.3.3': v1_3_3,
    '1.3.2': v1_3_2,
    '1.3.1': v1_3_1,
    '1.3.0': v1_3_0,
    '1.2.0': v1_2_0,
    '1.1.2': v1_1_2,
    '1.1.1': v1_1_1,
    '1.1.0': v1_1_0,
    '1.0.1': v1_0_1,
    '1.0.0': v1_0_0,
}
